import { getObjectUtil } from 'packages/src'
import getWorkoutExercisesWorkoutSectionUtil from '../../../workout-section/model/utils/get-workout-exercises'
import getWorkoutSectionsWorkoutUtil from '../../../../modules/workout/model/utils/get-workout-sections'
import isLoggedWorkoutUtil from '../../../../modules/workout/model/utils/is-logged'
import setReduxAction from '../../../redux/actions/set'
import { getActionStrReduxUtil } from '../../../redux/utils/get-action-str'
import { getIdReduxUtil } from '../../../redux/utils/get-id'
import getInstanceReduxUtil from '../../../redux/utils/get-instance'
import resetStartWorkoutAction from '../reset'
import updateHasStartedStartWorkoutAction from '../set-has-started'
import {
  START_WORKOUT_ACTION,
  START_WORKOUT_ANALYTICS_EVENT,
  START_WORKOUT_PATH
} from '../../constants'
import { updateCurrentSetIndexWorkoutExerciseAction } from '../../../workout-exercise/redux/actions'
import updateCurrentWorkoutSectionAction from '../../../workout-section/redux/actions/update-current'
import WORKOUT_SECTIONS_PATH from '../../../workout-section/redux/constants/path'
import {
  cloneIfCantEditWorkoutAction,
  copyWorkoutAction,
  saveWorkoutAction,
  updateStartedAtWorkoutAction
} from '../../../workout/redux/actions'
import setStartedWorkoutAction from '../../../workout/redux/actions/set-started'
import { logEventAnalyticsUtil } from '../../../../utils/analytics/log-event'

export default function startWorkoutAction (callback) {
  return async (dispatch, getState) => {
    dispatch(resetStartWorkoutAction())

    let workout = await dispatch(cloneIfCantEditWorkoutAction())

    if (isLoggedWorkoutUtil(workout)) {
      workout = await dispatch(copyWorkoutAction({
        id: getIdReduxUtil(workout)
      }))
    }

    dispatch(updateHasStartedStartWorkoutAction(true))

    dispatch(saveWorkoutAction(getIdReduxUtil(workout)))

    workout = getInstanceReduxUtil(getState(), workout)
    // const newWorkout = await dispatch(
    //   cloneWorkoutAction({
    //     isLog: true
    //   })
    // )

    dispatch(setStartedWorkoutAction(workout))

    dispatch(updateStartedAtWorkoutAction())

    const workoutSectionPointers = getWorkoutSectionsWorkoutUtil(workout)
    const workoutSectionsDomainMap = getObjectUtil(getState(), WORKOUT_SECTIONS_PATH.DATA)
    const index = workoutSectionPointers.findIndex(workoutSectionPointer => {
      const id = getIdReduxUtil(workoutSectionPointer)
      const workoutSection = workoutSectionsDomainMap[id]
      const workoutExercisePointers = getWorkoutExercisesWorkoutSectionUtil(
        workoutSection)
      return workoutExercisePointers.length > 0
    })

    dispatch(setReduxAction({
      type: getActionStrReduxUtil(START_WORKOUT_ACTION.UPDATE_STARTING_WORKOUT_SECTION,
        index
      ),
      payload: {
        path: START_WORKOUT_PATH.CURRENT_WORKOUT_SECTION_INDEX,
        value: index
      }
    }))

    const currentWorkoutSectionPointer = workoutSectionPointers[index]
    dispatch(updateCurrentWorkoutSectionAction(getIdReduxUtil(
      currentWorkoutSectionPointer)))
    dispatch(updateCurrentSetIndexWorkoutExerciseAction(0))

    logEventAnalyticsUtil(START_WORKOUT_ANALYTICS_EVENT.STARTED, workout)

    callback()
  }
}
